import type {TreePayload} from '@github-ui/code-view-types'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Box} from '@primer/react'

import {useOpenPanel} from '../contexts/OpenPanelContext'
import {CurrentTreeProvider} from '../hooks/CurrentTree'
import {BranchInfoBar, BranchInfoBarErrorBanner} from './directory/BranchInfoBar/BranchInfoBar'
import DirectoryContent from './directory/DirectoryContent'
import {DirectoryReadmePreview} from './directory/DirectoryContent/DirectoryReadmePreview'
import FolderViewHeader from './headers/FolderViewHeader'
import {LatestCommitSingleLine} from './LatestCommit'

export default function FileTreeViewContent({
  tree,
  showTree,
  treeToggleElement,
}: {
  tree: TreePayload
  showTree: boolean
  treeToggleElement: JSX.Element
}) {
  const {openPanel, setOpenPanel} = useOpenPanel()

  return (
    <CurrentTreeProvider payload={tree}>
      <LatestCommitSingleLine />

      {tree.showBranchInfobar && (
        <ErrorBoundary fallback={<BranchInfoBarErrorBanner />}>
          <BranchInfoBar />
        </ErrorBoundary>
      )}
      <FolderViewHeader showTree={showTree} treeToggleElement={treeToggleElement} />
      <Box sx={{display: 'flex', flexDirection: 'column', gap: 3}}>
        <Box>
          <DirectoryContent />
        </Box>
        {tree.readme && (
          <DirectoryReadmePreview
            openPanel={openPanel}
            setOpenPanel={setOpenPanel}
            readme={tree.readme}
            stickyHeaderHeight={50}
          />
        )}
      </Box>
    </CurrentTreeProvider>
  )
}

try{ FileTreeViewContent.displayName ||= 'FileTreeViewContent' } catch {}